import React from 'react';
import UnrateItemsDesktop from './UnrateItemsDesktop';
import UnrateItemsMobile from './UnrateItemsMobile';

const UnrateItems = (props: any) => {
  const {
    isDesktop = false,
    rateProductModal,
    isRating,
    isCustomerWord,
    toggleOn,
    showRateProdBtn,
    showReviewProdBtn,
    enableRating,
    enableReview,
    isFleek = false
  } = props;
  let btnCta = '';
  if (enableReview && showReviewProdBtn) {
    btnCta = 'Write a Review';
  } else if (showRateProdBtn && enableRating) {
    btnCta = 'Rate this Product';
  } else {
    return null;
  }

  return (
    <>
      {isDesktop ? (
        <UnrateItemsDesktop
          btnCta={btnCta}
          rateProductModal={rateProductModal}
          isRating={isRating}
          isCustomerWord={isCustomerWord}
        />
      ) : (
        <UnrateItemsMobile
          btnCta={btnCta}
          rateProductModal={rateProductModal}
          isRating={isRating}
          toggleOn={toggleOn}
          isFleek={isFleek}
        />
      )}
    </>
  );
};

export default UnrateItems;
